import { useEffect, useState } from 'react';

const read = (token: string, fallback: string) =>
  getComputedStyle(document.documentElement).getPropertyValue(token).trim() || fallback;

export const useThemeColor = (token: string, fallback: string) => {
  const [color, setColor] = useState(() => read(token, fallback));

  useEffect(() => {
    const observer = new MutationObserver(() => setColor(read(token, fallback)));
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme'],
    });
    return () => observer.disconnect();
  }, [token, fallback]);

  return color;
};
